import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';
import { SessionService } from '../session/session.service';

export const authHttpInterceptor: HttpInterceptorFn = (request, next) => {
  const _sessionService = inject(SessionService);

  const token = _sessionService.getToken();

  const clientId = environment.clientId;

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
      setParams: {
        'client-id': clientId,
      },
    });
  }

  return next(request);
};
